import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { snakeToCamel } from "caseparser";

export const gymsApi = api
  .enhanceEndpoints({ addTagTypes: ["gyms"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      gyms: builder.query({
        query: () => ({
          url: "admin/branchs/gyms",
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      fetchGyms: builder.mutation({
        query: (searchTerm) => ({
          url: "admin/gyms/search",
          method: RequestMethod.POST,
          body: searchTerm,
        }),
      }),
      gymsByAccessUser: builder.query({
        query: () => ({
          url: "admin/gyms/gymByAccessUser",
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      deleteGym: builder.mutation({
        query: (gymId) => ({
          url: `admin/gyms/${gymId}`,
          method: RequestMethod.DELETE,
        }),
      }),
      createGym: builder.mutation({
        query: (gymData) => ({
          url: "admin/gyms",
          method: RequestMethod.POST,
          body: gymData,
        }),
      }),
      updateGym: builder.mutation({
        query: ({ gymId, gymData }) => ({
          url: `admin/gyms/${gymId}`,
          method: RequestMethod.POST,
          body: gymData,
        }),
      }),
    }),
  });

export const {
  useFetchGymsMutation,
  useDeleteGymMutation,
  useCreateGymMutation,
  useUpdateGymMutation,
  useGymsQuery,
  useGymsByAccessUserQuery,
} = gymsApi;
